import React from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import { setSidebarTab, useInspectorDrawerOpen, useSelectedSidebarTab } from '../../documents/editor/EditorContext';

import ConfigurationPanel from './ConfigurationPanel';
import StylesPanel from './StylesPanel';

export const INSPECTOR_DRAWER_WIDTH = 320;

const TABS_SX = {
  minHeight: 40,
  '& .MuiTab-root': {
    minHeight: 40,
    py: 0.75,
  },
};

const EMBEDDED_TABS_SX = {
  minHeight: 36,
  '& .MuiTab-root': {
    minHeight: 36,
    py: 0.5,
  },
};

export function InspectorDrawerTabsBar({ embedded = false }: { embedded?: boolean }) {
  const selectedSidebarTab = useSelectedSidebarTab();

  return (
    <Box
      sx={{
        width: '100%',
        height: embedded ? 'auto' : 49,
        minHeight: embedded ? 'auto' : 49,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        ...(!embedded && {
          borderBottom: 1,
          borderColor: 'divider',
        }),
      }}
    >
      <Box px={2} width="100%">
        <Tabs
          value={selectedSidebarTab}
          onChange={(_, v) => setSidebarTab(v)}
          sx={embedded ? EMBEDDED_TABS_SX : TABS_SX}
        >
          <Tab value="styles" label="Styles" />
          <Tab value="block-configuration" label="Inspect" />
        </Tabs>
      </Box>
    </Box>
  );
}

interface InspectorDrawerProps {
  showTabs?: boolean;
}

export default function InspectorDrawer({ showTabs = true }: InspectorDrawerProps) {
  const selectedSidebarTab = useSelectedSidebarTab();
  const inspectorDrawerOpen = useInspectorDrawerOpen();

  if (!inspectorDrawerOpen) {
    return null;
  }

  const renderCurrentSidebarPanel = () => {
    switch (selectedSidebarTab) {
      case 'block-configuration':
        return <ConfigurationPanel />;
      case 'styles':
        return <StylesPanel />;
    }
  };

  return (
    <Box
      sx={{
        width: INSPECTOR_DRAWER_WIDTH,
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
        borderLeft: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      {showTabs && <InspectorDrawerTabsBar />}
      <Box sx={{ flex: 1, minHeight: 0, width: '100%', overflow: 'auto' }}>
        {renderCurrentSidebarPanel()}
      </Box>
    </Box>
  );
}
